import { MESApiService } from "@dexteel/mesf-core";

export const getLadleStatusReport = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MS].[GetLadleStatus]", []);
	return resp;
};
